const CLEAR_COMM_UPGRADE_DATA = "CLEAR_COMM_UPGRADE_DATA";
const TOGGLE_COMM_UPGRADES_LOADING = "TOGGLE_COMM_UPGRADES_LOADING";
const SET_COMM_UPGRADES_ERROR = "SET_COMM_UPGRADES_ERROR";
const SET_COMM_BASE_MODEL_ID = "SET_COMM_BASE_MODEL_ID";
const ADD_COMM_UPGRADE_PACKAGE = "ADD_COMM_UPGRADE_PACKAGE";
const UPDATE_COMM_UPGRADE_PACKAGE = "UPDATE_COMM_UPGRADE_PACKAGE";
const SET_COMM_UPGRADE_PACKAGES = "SET_COMM_UPGRADE_PACKAGES";
const DELETE_COMM_UPGRADE_PACKAGE = "DELETE_COMM_UPGRADE_PACKAGE";
const SET_INIT_COMM_UPGRADE_PACKAGES = "SET_INIT_COMM_UPGRADE_PACKAGES";
const UPDATE_COMM_PACKAGE_UPGRADES = "UPDATE_COMM_PACKAGE_UPGRADES";
const DELETE_COMM_PACKAGE_UPGRADE = "DELETE_COMM_PACKAGE_UPGRADE";
const UPDATE_COMM_UPGRADE_PACKAGE_ORDER = "UPDATE_COMM_UPGRADE_PACKAGE_ORDER";
const UPDATE_COMM_UPGRADE_COST = "UPDATE_COMM_UPGRADE_COST";
const UPDATE_COMM_PACKAGE_OPERATING_CONDITIONS = "UPDATE_COMM_PACKAGE_OPERATING_CONDITIONS";
const UPDATE_COMM_PACKAGE_BASE_CASE = "UPDATE_COMM_PACKAGE_BASE_CASE";
const UPDATE_COMM_UPGRADE_SNAPSHOT_START = "UPDATE_COMM_UPGRADE_SNAPSHOT_START";
const UPDATE_COMM_UPGRADE_SNAPSHOT_SUCCESS = "UPDATE_COMM_UPGRADE_SNAPSHOT_SUCCESS";
const UPDATE_COMM_UPGRADE_SNAPSHOT_ERROR = "UPDATE_COMM_UPGRADE_SNAPSHOT_ERROR";
const ADJUST_COMM_PACKAGE_COST = "ADJUST_COMM_PACKAGE_COST";
const INIT_ALL_CAPITAL_COSTS = "INIT_ALL_CAPITAL_COSTS";
const REMOVE_COMM_MODEL_PACKAGE_COSTS = "REMOVE_COMM_MODEL_PACKAGE_COSTS";
const CALC_COMM_MODEL_PACKAGE_COST = "CALC_COMM_MODEL_PACKAGE_COST";
const SAVE_COMM_UPGRADES_START = "SAVE_COMM_UPGRADES_START";
const SAVE_COMM_UPGRADES_SUCCESS = "SAVE_COMM_UPGRADES_SUCCESS";

export default {
    CLEAR_COMM_UPGRADE_DATA,
    TOGGLE_COMM_UPGRADES_LOADING,
    SET_COMM_UPGRADES_ERROR,
    SET_COMM_BASE_MODEL_ID,
    ADD_COMM_UPGRADE_PACKAGE,
    UPDATE_COMM_UPGRADE_PACKAGE,
    SET_COMM_UPGRADE_PACKAGES,
    SET_INIT_COMM_UPGRADE_PACKAGES,
    DELETE_COMM_UPGRADE_PACKAGE,
    UPDATE_COMM_PACKAGE_UPGRADES,
    DELETE_COMM_PACKAGE_UPGRADE,
    UPDATE_COMM_UPGRADE_PACKAGE_ORDER,
    UPDATE_COMM_UPGRADE_COST,
    UPDATE_COMM_PACKAGE_OPERATING_CONDITIONS,
    UPDATE_COMM_PACKAGE_BASE_CASE,
    UPDATE_COMM_UPGRADE_SNAPSHOT_START,
    UPDATE_COMM_UPGRADE_SNAPSHOT_SUCCESS,
    UPDATE_COMM_UPGRADE_SNAPSHOT_ERROR,
    ADJUST_COMM_PACKAGE_COST,
    INIT_ALL_CAPITAL_COSTS,
    REMOVE_COMM_MODEL_PACKAGE_COSTS,
    CALC_COMM_MODEL_PACKAGE_COST,
    SAVE_COMM_UPGRADES_START,
    SAVE_COMM_UPGRADES_SUCCESS,
};
